module.exports = __webpack_public_path__ + "img/swiper-bg.d604d62.png";